(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7905],{

/***/ 42003:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// This icon file is generated automatically.
var EyeInvisibleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z" } }, { "tag": "path", "attrs": { "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z" } }] }, "name": "eye-invisible", "theme": "outlined" };
/* harmony default export */ __webpack_exports__["Z"] = (EyeInvisibleOutlined);


/***/ }),

/***/ 5717:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
// This icon file is generated automatically.
var EyeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z" } }] }, "name": "eye", "theme": "outlined" };
/* harmony default export */ __webpack_exports__["Z"] = (EyeOutlined);


/***/ }),

/***/ 57026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ph": function() { return /* binding */ Select; }
/* harmony export */ });
/* unused harmony exports DefaultIcon, SelectField */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54520);
// ../../../react-shim.js


// src/select.tsx



// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");
var dataAttr = (condition) => condition ? "" : void 0;

// ../../utilities/object-utils/src/index.ts
function split(object, keys) {
  const picked = {};
  const omitted = {};
  for (const [key, value] of Object.entries(object)) {
    if (keys.includes(key))
      picked[key] = value;
    else
      omitted[key] = value;
  }
  return [picked, omitted];
}

// src/select.tsx


// src/select-field.tsx

var SelectField = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)(function SelectField2(props, ref) {
  const { children, placeholder, className, ...rest } = props;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.select */ .m$.select, {
    ...rest,
    ref,
    className: cx("chakra-select", className)
  }, placeholder && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("option", {
    value: ""
  }, placeholder), children);
});
SelectField.displayName = "SelectField";

// src/select.tsx
var Select = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .forwardRef */ .Gp)((props, ref) => {
  var _a;
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useMultiStyleConfig */ .jC)("Select", props);
  const {
    rootProps,
    placeholder,
    icon,
    color,
    height,
    h,
    minH,
    minHeight,
    iconColor,
    iconSize,
    ...rest
  } = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .omitThemingProps */ .Lr)(props);
  const [layoutProps, otherProps] = split(rest, _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .layoutPropNames */ .oE);
  const ownProps = (0,_chakra_ui_form_control__WEBPACK_IMPORTED_MODULE_3__/* .useFormControl */ .Yp)(otherProps);
  const rootStyles = {
    width: "100%",
    height: "fit-content",
    position: "relative",
    color
  };
  const fieldStyles = {
    paddingEnd: "2rem",
    ...styles.field,
    _focus: {
      zIndex: "unset",
      ...(_a = styles.field) == null ? void 0 : _a["_focus"]
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra.div */ .m$.div, {
    className: "chakra-select__wrapper",
    __css: rootStyles,
    ...layoutProps,
    ...rootProps
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectField, {
    ref,
    height: h ?? height,
    minH: minH ?? minHeight,
    placeholder,
    ...ownProps,
    __css: fieldStyles
  }, props.children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectIcon, {
    "data-disabled": dataAttr(ownProps.disabled),
    ...(iconColor || color) && { color: iconColor || color },
    __css: styles.icon,
    ...iconSize && { fontSize: iconSize }
  }, icon));
});
Select.displayName = "Select";
var DefaultIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", {
  viewBox: "0 0 24 24",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}));
var IconWrapper = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .chakra */ .m$)("div", {
  baseStyle: {
    position: "absolute",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    top: "50%",
    transform: "translateY(-50%)"
  }
});
var SelectIcon = (props) => {
  const { children = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DefaultIcon, null), ...rest } = props;
  const clone = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(children, {
    role: "presentation",
    className: "chakra-select__icon",
    focusable: false,
    "aria-hidden": true,
    style: {
      width: "1em",
      height: "1em",
      color: "currentColor"
    }
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IconWrapper, {
    ...rest,
    className: "chakra-select__icon-wrapper"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(children) ? clone : null);
};
SelectIcon.displayName = "SelectIcon";



/***/ }),

/***/ 36158:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Od": function() { return /* binding */ Skeleton; }
});

// UNUSED EXPORTS: SkeletonCircle, SkeletonText

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/react-use-previous/dist/index.esm.js
// src/index.ts

function usePrevious(value) {
  const ref = (0,react.useRef)();
  (0,react.useEffect)(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}


// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 4 modules
var index_esm = __webpack_require__(15818);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/styled-system/dist/index.esm.js
var dist_index_esm = __webpack_require__(54520);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
;// CONCATENATED MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js
// ../../../react-shim.js


// src/skeleton.tsx


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/skeleton.tsx


// src/use-is-first-render.ts

function useIsFirstRender() {
  const isFirstRender = (0,react.useRef)(true);
  (0,react.useEffect)(() => {
    isFirstRender.current = false;
  }, []);
  return isFirstRender.current;
}

// src/skeleton.tsx
var StyledSkeleton = (0,index_esm/* chakra */.m$)("div", {
  baseStyle: {
    boxShadow: "none",
    backgroundClip: "padding-box",
    cursor: "default",
    color: "transparent",
    pointerEvents: "none",
    userSelect: "none",
    "&::before, &::after, *": {
      visibility: "hidden"
    }
  }
});
var $startColor = (0,dist_index_esm/* cssVar */.gJ)("skeleton-start-color");
var $endColor = (0,dist_index_esm/* cssVar */.gJ)("skeleton-end-color");
var fade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: { opacity: 0 },
  to: { opacity: 1 }
});
var bgFade = (0,emotion_react_browser_esm/* keyframes */.F4)({
  from: {
    borderColor: $startColor.reference,
    background: $startColor.reference
  },
  to: {
    borderColor: $endColor.reference,
    background: $endColor.reference
  }
});
var Skeleton = (0,index_esm/* forwardRef */.Gp)((props, ref) => {
  const styles = (0,index_esm/* useStyleConfig */.mq)("Skeleton", props);
  const isFirstRender = useIsFirstRender();
  const {
    startColor = "",
    endColor = "",
    isLoaded,
    fadeDuration,
    speed,
    className,
    ...rest
  } = (0,dist_index_esm/* omitThemingProps */.Lr)(props);
  const [startColorVar, endColorVar] = (0,index_esm/* useToken */.dQ)("colors", [
    startColor,
    endColor
  ]);
  const wasPreviouslyLoaded = usePrevious(isLoaded);
  const _className = cx("chakra-skeleton", className);
  const cssVarStyles = {
    ...startColorVar && { [$startColor.variable]: startColorVar },
    ...endColorVar && { [$endColor.variable]: endColorVar }
  };
  if (isLoaded) {
    const animation = isFirstRender || wasPreviouslyLoaded ? "none" : `${fade} ${fadeDuration}s`;
    return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
      ref,
      className: _className,
      __css: { animation },
      ...rest
    });
  }
  return /* @__PURE__ */ react.createElement(StyledSkeleton, {
    ref,
    className: _className,
    ...rest,
    __css: {
      ...styles,
      ...cssVarStyles,
      _dark: { ...cssVarStyles },
      animation: `${speed}s linear infinite alternate ${bgFade}`
    }
  });
});
Skeleton.defaultProps = {
  fadeDuration: 0.4,
  speed: 0.8
};
Skeleton.displayName = "Skeleton";

// src/skeleton-text.tsx


function range(count) {
  return Array(count).fill(1).map((_, index) => index + 1);
}
var defaultNoOfLines = 3;
var SkeletonText = (props) => {
  const {
    noOfLines = defaultNoOfLines,
    spacing = "0.5rem",
    skeletonHeight = "0.5rem",
    className,
    startColor,
    endColor,
    isLoaded,
    fadeDuration,
    speed,
    children,
    ...rest
  } = props;
  const noOfLinesValue = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)(typeof noOfLines === "number" ? [noOfLines] : noOfLines) || defaultNoOfLines;
  const numbers = range(noOfLinesValue);
  const getWidth = (index) => {
    if (noOfLinesValue > 1) {
      return index === numbers.length ? "80%" : "100%";
    }
    return "100%";
  };
  const _className = cx("chakra-skeleton__group", className);
  return /* @__PURE__ */ react.createElement(index_esm/* chakra.div */.m$.div, {
    className: _className,
    ...rest
  }, numbers.map((number, index) => {
    if (isLoaded && index > 0) {
      return null;
    }
    const sizeProps = isLoaded ? null : {
      mb: number === numbers.length ? "0" : spacing,
      width: getWidth(number),
      height: skeletonHeight
    };
    return /* @__PURE__ */ react.createElement(Skeleton, {
      key: numbers.length.toString() + number,
      startColor,
      endColor,
      isLoaded,
      fadeDuration,
      speed,
      ...sizeProps
    }, index === 0 ? children : void 0);
  }));
};
SkeletonText.displayName = "SkeletonText";

// src/skeleton-circle.tsx
var SkeletonCircle = ({
  size = "2rem",
  ...rest
}) => /* @__PURE__ */ react.createElement(Skeleton, {
  borderRadius: "full",
  boxSize: size,
  ...rest
});
SkeletonCircle.displayName = "SkeletonCircle";



/***/ }),

/***/ 95159:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[slug]",
      function () {
        return __webpack_require__(30289);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47741);
/* harmony import */ var components_inputs_InputCheckboxGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26430);
/* harmony import */ var components_inputs_InputTextGroup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80929);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35656);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87536);
/* harmony import */ var _AuthSocialLogin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97817);








function AuthLoginForm(param) {
    let { onSubmit , loading =false  } = param;
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)([
        "auth",
        "common"
    ]);
    // use react-hook-form
    const { control , handleSubmit  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_6__/* .useForm */ .cI)({
        mode: "onChange"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Stack */ .Kq, {
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs_InputTextGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: "email",
                            type: "email",
                            label: t("form.label.email", {
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs_InputTextGroup__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: "password",
                            type: "password",
                            label: t("form.label.password", {
                                ns: "common"
                            }),
                            control: control,
                            rules: {
                                required: {
                                    value: true,
                                    message: t("form.message.required", {
                                        ns: "common"
                                    })
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .HStack */ .Ug, {
                        justifyContent: "space-between",
                        mt: 3,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs_InputCheckboxGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                    name: "remember",
                                    label: t("auth.form.label.remember", {
                                    }),
                                    control: control,
                                    rules: {
                                        required: false
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    href: "/forgot-password",
                                    passHref: true,
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .rU, {
                                        children: t("auth.form.label.forgotPassword", {
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Box */ .xu, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .zx, {
                            type: "submit",
                            bg: "gray.800",
                            width: "100%",
                            isLoading: loading,
                            children: t("auth.login.form.button.login", {
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Center */ .M5, {
                        py: 1,
                        children: t("auth.form.social.divider", {
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AuthSocialLogin__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AuthLoginForm);


/***/ }),

/***/ 97817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47741);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35656);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




function AuthSocialLogin() {
    // use i18n
    const { t  } = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)([
        "auth"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                mb: 3,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    as: "a",
                    colorScheme: "facebook",
                    width: "100%",
                    href: "".concat("https://api.lamptan.co.th", "/v1/auth/facebook"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/image-icon/login-fb.png",
                                    alt: "facebook",
                                    width: 22,
                                    height: 22,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: t("auth.form.social.loginWithFacebook", {
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                    as: "a",
                    variant: "outline",
                    colorScheme: "gray",
                    border: "1px solid",
                    borderColor: "gray.200",
                    width: "100%",
                    _hover: {
                        bg: "gray.50"
                    },
                    href: "".concat("https://api.lamptan.co.th", "/v1/auth/google"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .Ug, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "/image-icon/login-google.png",
                                    alt: "google",
                                    width: 24,
                                    height: 24,
                                    quality: 100
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .xv, {
                                children: t("auth.form.social.loginWithGoogle", {
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (AuthSocialLogin);


/***/ }),

/***/ 26430:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83234);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9135);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87536);




function InputCheckboxGroup(param) {
    let { name , label , placeholder , description , control , rules , watch , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_2__/* .Controller */ .Qr, {
        control: control,
        render: (param)=>{
            let { field: { onChange , value  } , formState: { errors  }  } = param;
            var _errors_name, _errors_name1;
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormControl */ .NI, {
                isInvalid: name in errors,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Checkbox */ .XZ, {
                        ...rest,
                        value: value !== null && value !== void 0 ? value : "",
                        isChecked: value,
                        onChange: (val)=>onChange(val),
                        children: label
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormHelperText */ .Q6, {
                        children: description
                    }),
                    ((_errors_name = errors[name]) === null || _errors_name === void 0 ? void 0 : _errors_name.message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .FormErrorMessage */ .J1, {
                        mt: 1,
                        children: (_errors_name1 = errors[name]) === null || _errors_name1 === void 0 ? void 0 : _errors_name1.message
                    })
                ]
            });
        },
        name: name,
        rules: rules
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (InputCheckboxGroup);


/***/ }),

/***/ 80929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ inputs_InputTextGroup; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeInvisibleOutlined.js
var asn_EyeInvisibleOutlined = __webpack_require__(42003);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeInvisibleOutlined/* default */.Z
  }));
};
EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
/* harmony default export */ var icons_EyeInvisibleOutlined = (/*#__PURE__*/react.forwardRef(EyeInvisibleOutlined));
// EXTERNAL MODULE: ./node_modules/@ant-design/icons-svg/es/asn/EyeOutlined.js
var asn_EyeOutlined = __webpack_require__(5717);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/EyeOutlined.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var EyeOutlined = function EyeOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_EyeOutlined/* default */.Z
  }));
};
EyeOutlined.displayName = 'EyeOutlined';
/* harmony default export */ var icons_EyeOutlined = (/*#__PURE__*/react.forwardRef(EyeOutlined));
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/index.esm.js
var index_esm = __webpack_require__(83234);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var dist_index_esm = __webpack_require__(20979);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var react_hook_form_dist_index_esm = __webpack_require__(87536);
;// CONCATENATED MODULE: ./components/inputs/InputTextGroup.tsx






function InputTextGroup(param) {
    let { name , label , type , placeholder , description , control , rules , watch , ...rest } = param;
    const [passwordShown, setPasswordShown] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hook_form_dist_index_esm/* Controller */.Qr, {
        control: control,
        render: (param)=>{
            let { field: { onChange , value  } , formState: { errors  }  } = param;
            var _get, _get1, _get2, _get3;
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(index_esm/* FormControl */.NI, {
                isInvalid: ((_get = (0,lodash.get)(errors, name)) === null || _get === void 0 ? void 0 : _get.message) !== "" && ((_get1 = (0,lodash.get)(errors, name)) === null || _get1 === void 0 ? void 0 : _get1.message) !== undefined,
                children: [
                    label && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormLabel */.lX, {
                        mb: 1,
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* InputGroup */.BZ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Input */.II, {
                                ...rest,
                                type: type ? type === "password" ? passwordShown ? "text" : "password" : type : "text",
                                name: name,
                                placeholder: placeholder,
                                onChange: (val)=>onChange(val),
                                value: value !== null && value !== void 0 ? value : ""
                            }),
                            type === "password" && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* InputRightElement */.xH, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                    size: "sm",
                                    onClick: ()=>{
                                        setPasswordShown(!passwordShown);
                                    },
                                    variant: "unstyled",
                                    paddingLeft: 2,
                                    paddingRight: 4,
                                    minWidth: "auto",
                                    children: passwordShown ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EyeInvisibleOutlined, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_EyeOutlined, {})
                                })
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormHelperText */.Q6, {
                        children: description
                    }),
                    ((_get2 = (0,lodash.get)(errors, name)) === null || _get2 === void 0 ? void 0 : _get2.message) && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FormErrorMessage */.J1, {
                        mt: 1,
                        children: (_get3 = (0,lodash.get)(errors, name)) === null || _get3 === void 0 ? void 0 : _get3.message
                    })
                ]
            });
        },
        name: name,
        rules: rules
    });
}
/* harmony default export */ var inputs_InputTextGroup = (InputTextGroup);


/***/ }),

/***/ 64070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_header_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/breadcrumb/AppBreadcrumb.tsx





function AppBreadcrumb(param) {
    let { breadcrumb  } = param;
    // use router
    const { pathname  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Breadcrumb */.aG, {
            separator: ">",
            color: "gray.600",
            className: "app-breadcrumb",
            children: breadcrumb.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbItem */.gN, {
                    isCurrentPage: pathname === item.href,
                    children: item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbLink */.At, {
                            children: item.label
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        noOfLines: 1,
                        children: item.label
                    })
                }, index))
        })
    });
}
/* harmony default export */ var breadcrumb_AppBreadcrumb = (AppBreadcrumb);

;// CONCATENATED MODULE: ./components/page-header/PageHeader.tsx




function PageHeader(param) {
    let { title , breadcrumb , backLink , containerMaxWidth ="850px"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "primary.400",
                pt: 8,
                pb: 4,
                bgGradient: "linear(to-t, white 55%, #ffd5b1 100%)",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    maxWidth: containerMaxWidth,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "lg",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            fontSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                                breadcrumb: breadcrumb
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: 2,
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "md",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                            breadcrumb: breadcrumb
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_header_PageHeader = (PageHeader);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function ProductBadge(param) {
    let { type ="special-price" , imageName  } = param;
    const badge = {
        "special-price": {
            src: "/badge/special-price.png",
            alt: "sale"
        },
        new: {
            src: "/badge/new-arrival.png",
            alt: "new"
        },
        "best-seller": {
            src: "/badge/bestseller.png",
            alt: "best-seller"
        },
        "1get1": {
            src: "/badge/1get1.png",
            alt: "1get1"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: imageName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "".concat("https://storage.lamptan.co.th", "/").concat(imageName),
            alt: imageName,
            width: 50,
            height: 50
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: badge[type].src,
            alt: badge[type].alt,
            width: 50,
            height: 50
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductBadge);


/***/ }),

/***/ 30289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons-svg/es/asn/InfoCircleFilled.js
var asn_InfoCircleFilled = __webpack_require__(12489);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/components/AntdIcon.js + 5 modules
var AntdIcon = __webpack_require__(89099);
;// CONCATENATED MODULE: ./node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js

// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY



var InfoCircleFilled = function InfoCircleFilled(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: asn_InfoCircleFilled/* default */.Z
  }));
};
InfoCircleFilled.displayName = 'InfoCircleFilled';
/* harmony default export */ var icons_InfoCircleFilled = (/*#__PURE__*/react.forwardRef(InfoCircleFilled));
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var skeleton_dist_index_esm = __webpack_require__(36158);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/select/dist/index.esm.js
var select_dist_index_esm = __webpack_require__(57026);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js
var accordion_dist_index_esm = __webpack_require__(31937);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js
var message = __webpack_require__(45360);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(39653);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 51 modules
var modal_dist_index_esm = __webpack_require__(26117);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(70594);
// EXTERNAL MODULE: ./hooks/useCatchError.ts
var useCatchError = __webpack_require__(65633);
// EXTERNAL MODULE: ./hooks/useUser.ts + 1 modules
var useUser = __webpack_require__(42409);
// EXTERNAL MODULE: ./libs/axios.ts
var libs_axios = __webpack_require__(64232);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./components/auth/AuthLoginForm.tsx
var AuthLoginForm = __webpack_require__(4608);
;// CONCATENATED MODULE: ./components/auth/AuthLoginModal.tsx










function AuthLoginModal(param) {
    let { visible , onClose  } = param;
    // init i18n
    const { t  } = (0,useTranslation/* useTranslation */.$)([
        "auth",
        "common"
    ]);
    // use catchError
    const catchError = (0,useCatchError/* default */.Z)();
    // use user
    const { updateUser , mutateUser  } = (0,useUser/* default */.Z)();
    const { isOpen , onClose: onDisclosureClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)({
        isOpen: visible
    });
    // init loading state
    const [loading, setLoading] = (0,react.useState)(false);
    const handleSubmit = async (values)=>{
        try {
            ;
            setLoading(true);
            const { data  } = await axios/* default.post */.Z.post("/api/users/login-session", values);
            if (data.accessToken) {
                libs_axios/* default.defaults.headers.common.Authorization */.Z.defaults.headers.common.Authorization = "Bearer ".concat(data.accessToken);
                // update user by mutate SWR
                mutateUser(data, false);
                updateUser(data);
                handleClosed();
            }
        } catch (error) {
            catchError(error);
        } finally{
            setLoading(false);
        }
    };
    const handleClosed = ()=>{
        onDisclosureClose();
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: handleClosed,
        isCentered: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalContent */.hz, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* ModalBody */.fe, {
                    py: 6,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                            textAlign: "center",
                            mb: 3,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                    children: t("auth.login.title")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalCloseButton */.ol, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            mb: 4,
                            borderBottom: "1px solid #eee",
                            pb: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLoginForm/* default */.Z, {
                                onSubmit: handleSubmit,
                                loading: loading
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                            height: "100%",
                            bg: "#EADECE",
                            p: {
                                base: 7,
                                lg: 4
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                textAlign: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        as: "h2",
                                        mb: 3,
                                        fontWeight: "300",
                                        children: t("auth.register.callAction.title", {
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/register",
                                        passHref: true,
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                            as: "a",
                                            bg: "gray.800",
                                            minWidth: "150px",
                                            children: t("auth.register.callAction.button", {
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var auth_AuthLoginModal = (AuthLoginModal);

// EXTERNAL MODULE: ./components/inputs/InputNumber.tsx
var InputNumber = __webpack_require__(55947);
// EXTERNAL MODULE: ./components/page-header/PageHeader.tsx + 1 modules
var PageHeader = __webpack_require__(64070);
// EXTERNAL MODULE: ./components/products/ProductBadge.tsx
var ProductBadge = __webpack_require__(21572);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/LeftOutlined.js
var LeftOutlined = __webpack_require__(37653);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/RightOutlined.js
var RightOutlined = __webpack_require__(43929);
;// CONCATENATED MODULE: ./components/products/ProductGallerySwiperLightBox.tsx






function ProductGallerySwiperLightBox(param) {
    let { imageSelected , images , onClosed  } = param;
    // use modal
    const { isOpen , onOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    const [controlledSwiper, setControlledSwiper] = (0,react.useState)();
    const [isReachEnded, setIsReachEnded] = (0,react.useState)(false);
    // imageSelected change
    (0,react.useEffect)(()=>{
        if (imageSelected) {
            onOpen();
            // find index of imageSelected
            const index = images.findIndex((image)=>image.id === imageSelected.id);
            // set swiper to index
            controlledSwiper === null || controlledSwiper === void 0 ? void 0 : controlledSwiper.slideTo(index, 0);
        }
    }, [
        imageSelected,
        controlledSwiper
    ]);
    // handle modal close
    const handleModalClose = ()=>{
        onClose();
        onClosed();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: handleModalClose,
        size: "3xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalContent */.hz, {
                margin: "auto",
                maxWidth: "532px",
                borderRadius: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                    padding: 4,
                    bg: "transparent",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Grid */.rj, {
                        templateColumns: "minmax(0, 1fr)",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                            position: "relative",
                            height: "100%",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    height: "100%",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                        spaceBetween: 4,
                                        slidesPerView: 1,
                                        resistance: false,
                                        onSwiper: (swiper)=>setControlledSwiper(swiper),
                                        onReachEnd: ()=>setIsReachEnded(true),
                                        onReachBeginning: ()=>setIsReachEnded(false),
                                        children: images.map((image, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                style: {
                                                    width: "100%",
                                                    height: controlledSwiper ? controlledSwiper.size : 400
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: image.url,
                                                    alt: image.name,
                                                    width: 532,
                                                    height: 532
                                                })
                                            }, index))
                                    })
                                }),
                                controlledSwiper ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                            position: "absolute",
                                            left: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            fontSize: "4xl",
                                            colorScheme: "primary",
                                            variant: "link",
                                            zIndex: "docked",
                                            onClick: ()=>controlledSwiper.slidePrev(),
                                            "aria-label": "Prev",
                                            background: "rgba(0,0,0, 0.5)",
                                            borderRadius: "none",
                                            minW: "auto",
                                            w: "36px",
                                            height: "50px",
                                            color: "white",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftOutlined/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* IconButton */.hU, {
                                            position: "absolute",
                                            right: 0,
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            fontSize: "4xl",
                                            colorScheme: "primary",
                                            variant: "link",
                                            zIndex: "docked",
                                            onClick: ()=>controlledSwiper.slideNext(),
                                            background: "rgba(0,0,0, 0.5)",
                                            borderRadius: "none",
                                            minW: "auto",
                                            w: "36px",
                                            height: "50px",
                                            "aria-label": "Next",
                                            color: "white",
                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RightOutlined/* default */.Z, {})
                                        })
                                    ]
                                }) : null
                            ]
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var products_ProductGallerySwiperLightBox = (ProductGallerySwiperLightBox);

;// CONCATENATED MODULE: ./components/products/ProductGallerySwiperVideoLightBox.tsx



function ProductGallerySwiperVideoLightBox(param) {
    let { videoUrl , visible , onClosed  } = param;
    // use modal
    const { isOpen , onClose  } = (0,hooks_dist_index_esm/* useDisclosure */.qY)({
        isOpen: visible
    });
    // youtube video id
    const [youtubeVideoId, setYoutubeVideoId] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        if (videoUrl) {
            // get youtube video id after last slash
            const videoId = videoUrl.split("/").pop();
            ;
            if (videoId) {
                setYoutubeVideoId(videoId);
            }
        }
    }, [
        videoUrl
    ]);
    // handle modal close
    const handleModalClose = ()=>{
        onClose();
        onClosed();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(modal_dist_index_esm/* Modal */.u_, {
        isOpen: isOpen,
        onClose: handleModalClose,
        size: "5xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalOverlay */.ZA, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalContent */.hz, {
                margin: "auto",
                maxWidth: "900px",
                borderRadius: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_dist_index_esm/* ModalBody */.fe, {
                    padding: 4,
                    bg: "transparent",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                        className: "youtubeContainer",
                        children: youtubeVideoId ? /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            width: "900",
                            height: "506",
                            src: "https://www.youtube-nocookie.com/embed/".concat(youtubeVideoId),
                            title: "YouTube video player",
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                children: "Video not found. Please check the video url and try again."
                            })
                        })
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var products_ProductGallerySwiperVideoLightBox = (ProductGallerySwiperVideoLightBox);

;// CONCATENATED MODULE: ./components/products/ProductGallerySwiper.tsx








function ProductGallerySwiper(param) {
    let { product , currentProductVariation , images  } = param;
    // use media query
    const [isMobile] = (0,index_esm/* useMediaQuery */.ac)("(max-width: 767px)");
    // use media query
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 1200px)");
    // main swiper
    const [controlledSwiper, setControlledSwiper] = (0,react.useState)();
    // thumbnail swiper
    const [thumbsSwiper, setThumbsSwiper] = (0,react.useState)();
    const [thumbsSwiperMobile, setThumbsSwiperMobile] = (0,react.useState)();
    // main swiper end reached
    const [_, setIsReachEnded] = (0,react.useState)(false);
    // image view lightbox
    const [imageSelected, setImageSelected] = (0,react.useState)();
    // video lightbox visible
    const [videoLightBoxVisible, setVideoLightBoxVisible] = (0,react.useState)(false);
    // current active index
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    // ** set active index when currentProductVariation change
    (0,react.useEffect)(()=>{
        // ** Note: we need to slieTo index of currentProductVariation image in main swiper
        if (currentProductVariation && images && images.length > 0) {
            const index = images.findIndex((image)=>image.uniqueId === currentProductVariation.id);
            ;
            ;
            if (index !== -1) {
                setActiveIndex(index);
                controlledSwiper === null || controlledSwiper === void 0 ? void 0 : controlledSwiper.slideTo(index, 0);
            }
        } else {
            setActiveIndex(0);
            controlledSwiper === null || controlledSwiper === void 0 ? void 0 : controlledSwiper.slideTo(0, 0);
        }
    }, [
        currentProductVariation,
        images,
        controlledSwiper
    ]);
    var _image_url, _image_url1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                position: "relative",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        height: "100%",
                        position: "absolute",
                        left: "-96px",
                        width: "66px",
                        children: images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            modules: [
                                swiper_esm/* Thumbs */.o3,
                                swiper_esm/* FreeMode */.Rv
                            ],
                            spaceBetween: 10,
                            slidesPerView: 5,
                            direction: "vertical",
                            freeMode: true,
                            watchSlidesProgress: true,
                            onSwiper: (swiper)=>{
                                setThumbsSwiper(swiper);
                            },
                            style: {
                                height: controlledSwiper === null || controlledSwiper === void 0 ? void 0 : controlledSwiper.size
                            },
                            threshold: 15,
                            grabCursor: true,
                            children: images.map((image, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    children: (param)=>/*#__PURE__*/ {
                                        let { isActive  } = param;
                                        return (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                                            ratio: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                height: "100%",
                                                w: "100%",
                                                cursor: "pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (_image_url = image.url) !== null && _image_url !== void 0 ? _image_url : "/image-icon/empty-image.png",
                                                    alt: image.name,
                                                    width: 100,
                                                    height: 100,
                                                    quality: 95,
                                                    priority: true,
                                                    style: {
                                                        objectFit: "cover",
                                                        objectPosition: "center",
                                                        height: "100%"
                                                    }
                                                })
                                            })
                                        });
                                    }
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        children: images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                            modules: [
                                swiper_esm/* Thumbs */.o3,
                                swiper_esm/* Pagination */.tl
                            ],
                            spaceBetween: 2,
                            slidesPerView: 1,
                            onSlideChange: (swiper)=>setActiveIndex(swiper.activeIndex),
                            onSwiper: (swiper)=>setControlledSwiper(swiper),
                            onReachEnd: ()=>setIsReachEnded(true),
                            onReachBeginning: ()=>setIsReachEnded(false),
                            grabCursor: true,
                            pagination: {
                                clickable: true
                            },
                            thumbs: {
                                swiper: isDesktop && thumbsSwiper ? thumbsSwiper : isMobile && thumbsSwiperMobile ? thumbsSwiperMobile : null
                            },
                            threshold: 15,
                            loopFillGroupWithBlank: false,
                            children: images.map((image, index)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    style: {
                                        width: "100%",
                                        height: "100%",
                                        maxHeight: controlledSwiper === null || controlledSwiper === void 0 ? void 0 : controlledSwiper.size
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: (_image_url1 = image.url) !== null && _image_url1 !== void 0 ? _image_url1 : "/image-icon/empty-image.png",
                                        alt: image.name,
                                        width: 500,
                                        height: 500,
                                        quality: 100,
                                        priority: true,
                                        style: {
                                            objectFit: "cover",
                                            objectPosition: "center",
                                            height: "100%"
                                        }
                                    })
                                }, index);
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                            height: "100%",
                            width: "100%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/image-icon/empty-image.png",
                                alt: "empty-image",
                                width: 500,
                                height: 500,
                                quality: 100
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                        position: "absolute",
                        bottom: 3,
                        left: 3,
                        zIndex: "docked",
                        children: [
                            product.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                onClick: ()=>setVideoLightBoxVisible(true),
                                colorScheme: "gray",
                                bg: "gray.100",
                                minW: "auto",
                                w: "44px",
                                height: "44px",
                                borderRadius: "100%",
                                padding: "0",
                                _hover: {
                                    bg: "gray.50"
                                },
                                pl: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/image-icon/play.png",
                                    alt: "play",
                                    width: 18,
                                    height: 24
                                })
                            }),
                            images.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                onClick: ()=>setImageSelected(images[activeIndex]),
                                colorScheme: "gray",
                                bg: "gray.100",
                                minW: "auto",
                                w: "44px",
                                height: "44px",
                                borderRadius: "100%",
                                padding: "0",
                                _hover: {
                                    bg: "gray.50"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/image-icon/arrow-zoom.png",
                                    alt: "zoom",
                                    width: 24,
                                    height: 24
                                })
                            })
                        ]
                    }),
                    controlledSwiper ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                position: "absolute",
                                left: 4,
                                top: "50%",
                                transform: "translateY(-50%)",
                                colorScheme: "gray",
                                bg: "gray.100",
                                minW: "auto",
                                w: "30px",
                                height: "30px",
                                borderRadius: "100%",
                                padding: "0",
                                _hover: {
                                    bg: "gray.50"
                                },
                                _active: {
                                    bg: "gray.50"
                                },
                                zIndex: "docked",
                                onClick: ()=>controlledSwiper.slidePrev(),
                                isDisabled: controlledSwiper.isBeginning,
                                "aria-label": "Previous",
                                background: "gray.100",
                                display: {
                                    base: "none",
                                    lg: "inline-flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/image-icon/arrow-prev.png",
                                    alt: "prev",
                                    width: 16,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                position: "absolute",
                                right: 4,
                                top: "50%",
                                transform: "translateY(-50%)",
                                colorScheme: "gray",
                                bg: "gray.100",
                                minW: "auto",
                                w: "30px",
                                height: "30px",
                                borderRadius: "100%",
                                padding: "0",
                                _hover: {
                                    bg: "gray.50"
                                },
                                _active: {
                                    bg: "gray.50"
                                },
                                zIndex: "docked",
                                onClick: ()=>controlledSwiper.slideNext(),
                                isDisabled: controlledSwiper.isEnd,
                                "aria-label": "Next",
                                display: {
                                    base: "none",
                                    lg: "inline-flex"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/image-icon/arrow-next.png",
                                    alt: "prev",
                                    width: 16,
                                    height: 16
                                })
                            })
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                bg: "#EADECE",
                py: 2.5,
                display: {
                    lg: "none"
                },
                children: images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    modules: [
                        swiper_esm/* Thumbs */.o3,
                        swiper_esm/* FreeMode */.Rv
                    ],
                    spaceBetween: 10,
                    slidesPerView: isMobile ? 4.5 : 5,
                    direction: "horizontal",
                    freeMode: true,
                    watchSlidesProgress: true,
                    onSwiper: (swiper)=>{
                        setThumbsSwiperMobile(swiper);
                    },
                    grabCursor: true,
                    children: images.map((image, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: (param)=>/*#__PURE__*/ {
                                let { isActive  } = param;
                                return (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                                    ratio: 1,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                        height: "100%",
                                        w: "100%",
                                        cursor: "pointer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: image.url,
                                            alt: image.name,
                                            quality: 90,
                                            fill: true,
                                            style: {
                                                objectFit: "cover"
                                            }
                                        })
                                    })
                                });
                            }
                        }, index))
                }) : null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_ProductGallerySwiperVideoLightBox, {
                videoUrl: product.videoUrl || "",
                visible: videoLightBoxVisible,
                onClosed: ()=>setVideoLightBoxVisible(false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(products_ProductGallerySwiperLightBox, {
                imageSelected: imageSelected,
                images: images,
                onClosed: ()=>setImageSelected(undefined)
            })
        ]
    });
}
/* harmony default export */ var products_ProductGallerySwiper = (ProductGallerySwiper);

// EXTERNAL MODULE: ./components/utils/UtilPriceFormatter.tsx
var UtilPriceFormatter = __webpack_require__(74046);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(83022);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./hooks/useProduct.ts


function useProduct(param) {
    let { permalink ="" , queryStringify ="" , product =null , variation =null  } = param;
    const [productData, setProductData] = (0,react.useState)(null);
    const { data , error , mutate  } = (0,dist/* default */.ZP)(queryStringify && permalink ? "".concat("https://api.lamptan.co.th", "/v1/public/products/permalink/").concat(permalink, "?").concat(queryStringify) : undefined);
    const isLoading = !error && !data;
    const isError = error;
    (0,react.useEffect)(()=>{
        if (data) {
            setProductData({
                ...data
            });
        }
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        if (product) {
            setProductData({
                ...product,
                updatedAt: new Date()
            });
        }
    }, [
        product
    ]);
    return {
        product: productData,
        isLoading,
        isError,
        mutate
    };
}

// EXTERNAL MODULE: ./interfaces/product.interface.ts
var product_interface = __webpack_require__(75779);
// EXTERNAL MODULE: ./layouts/RootLayout.tsx + 10 modules
var RootLayout = __webpack_require__(89806);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(35656);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(17563);
// EXTERNAL MODULE: ./respository/cart.repository.ts
var cart_repository = __webpack_require__(61015);
// EXTERNAL MODULE: ./respository/user.repository.ts
var user_repository = __webpack_require__(48238);
// EXTERNAL MODULE: ./store/cart.store.ts
var cart_store = __webpack_require__(39098);
// EXTERNAL MODULE: ./store/product.store.ts
var product_store = __webpack_require__(42139);
// EXTERNAL MODULE: ./store/wishlist.store.ts
var wishlist_store = __webpack_require__(4295);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/native.js
const randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
/* harmony default export */ var esm_browser_native = ({
  randomUUID
});
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

const byteToHex = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

function unsafeStringify(arr, offset = 0) {
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  return (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase();
}

function stringify(arr, offset = 0) {
  const uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = ((/* unused pure expression or super */ null && (stringify)));
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js




function v4(options, buf, offset) {
  if (esm_browser_native.randomUUID && !buf && !options) {
    return esm_browser_native.randomUUID();
  }

  options = options || {};
  const rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (let i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return unsafeStringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ./pages/products/[slug].tsx































const productQueryObject = {
    include: [
        "featuredImage",
        "variations",
        "mainCategory",
        "breadcrumbCategories",
        "attributes",
        "attributeOptions",
        "tags",
        "gallery",
        "productBadge"
    ]
};
const ProductDetailPage = (param)=>{
    let { productProp  } = param;
    const { t  } = (0,esm/* useTranslation */.$G)([
        "product"
    ]);
    // use router
    const router = (0,next_router.useRouter)();
    const { locale  } = router;
    // use media query
    const [isMobile] = (0,index_esm/* useMediaQuery */.ac)("(max-width: 767px)");
    const [isTablet] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 768px)");
    const [isDesktop] = (0,index_esm/* useMediaQuery */.ac)("(min-width: 1024px)");
    // use user
    const { user  } = (0,useUser/* default */.Z)();
    // use cart
    const { cart , cartUpdate , cartMutate  } = (0,useCart/* default */.Z)();
    // use cart store
    const { setCart  } = (0,cart_store/* useCartStore */.x)();
    // use product
    const { product  } = useProduct({
        permalink: router.query.slug,
        queryStringify: query_string.stringify(productQueryObject)
    });
    // use notificaiton
    const [api, contextHolder] = message/* default.useMessage */.ZP.useMessage();
    // use catchError
    const catchError = (0,useCatchError/* default */.Z)();
    // get product detail prebreadcrumb
    const productDetailPreBreadcrumb = (0,product_store/* useProductStore */.a)((state)=>state.productDetailPreBreadcrumb);
    // use wishlist store
    const { wishlistsTotal , addWishlist , deleteWishlist , setWishlistsTotal  } = (0,wishlist_store/* useWishlistStore */.Y)();
    // get wishlist
    const { data: wishlistResponse  } = (0,dist/* default */.ZP)(()=>{
        return user && user.isAuthenticated && (productProp === null || productProp === void 0 ? void 0 : productProp.id) ? {
            url: "".concat("https://api.lamptan.co.th", "/v1/public/profile/wishlists/products/").concat(productProp.id),
            method: "GET",
            headers: {
                Authorization: "Bearer ".concat(user.accessToken)
            }
        } : null;
    });
    // init wishlist
    const [wishlist, setWishlist] = (0,react.useState)(wishlistResponse);
    // init wishlist loading
    const [wishlistLoading, setWishlistLoading] = (0,react.useState)(false);
    // init product attributes formatted
    const [productAttributesFormatted, setProductAttributesFormatted] = (0,react.useState)([]);
    // init current product variation selected
    const [currentProductVariation, setCurrentProductVariation] = (0,react.useState)();
    // init current attribute option selected
    const [currentAttributeOptionSelected, setCurrentAttributeOptionSelected] = (0,react.useState)([]);
    // init quantity
    // ** NOTE: set default value to 1
    const [quantity, setQuantity] = (0,react.useState)(1);
    // init breadcrumbs
    const [breadcrumbs, setBreadcrumbs] = (0,react.useState)([]);
    // init sale price
    const [salePrice, setSalePrice] = (0,react.useState)(0);
    // init regular price
    const [regularPrice, setRegularPrice] = (0,react.useState)(0);
    // init is out of stock
    const [isOutOfStock, setIsOutOfStock] = (0,react.useState)(false);
    // init login modal visible
    const [loginModalVisible, setLoginModalVisible] = (0,react.useState)(false);
    // init add to cart loading
    const [addToCartLoading, setAddToCartLoading] = (0,react.useState)(false);
    // ** set wishlist
    (0,react.useEffect)(()=>{
        if (wishlistResponse) {
            setWishlist(wishlistResponse);
        }
    }, [
        wishlistResponse
    ]);
    // ** set product breadcrumb categories
    (0,react.useEffect)(()=>{
        if (product) {
            if (product.breadcrumbCategories && product.mainCategory) {
                const breadcrumbCategory = product === null || product === void 0 ? void 0 : product.breadcrumbCategories[(product === null || product === void 0 ? void 0 : product.breadcrumbCategories.length) - 1];
                const _breadcrumb = [
                    {
                        label: t("breadcrumb.home", {
                            // TH: หน้าแรก
                            // EN: Home
                            ns: "common"
                        }),
                        href: "/"
                    }
                ];
                _breadcrumb.push({
                    label: product.mainCategory.name_th,
                    href: "/product-categories/".concat(product.mainCategory.permalink)
                });
                if (breadcrumbCategory) {
                    _breadcrumb.push({
                        label: breadcrumbCategory.name_th,
                        href: "/product-categories/".concat(product.mainCategory.permalink, "/").concat(breadcrumbCategory.permalink)
                    });
                }
                if (product.name_th) {
                    _breadcrumb.push({
                        label: product.name_en,
                        href: ""
                    });
                }
                setBreadcrumbs(_breadcrumb);
            }
            if (productDetailPreBreadcrumb && productDetailPreBreadcrumb.length > 0) {
                const _breadcrumb1 = (0,lodash.uniqBy)([
                    ...productDetailPreBreadcrumb
                ], "href");
                _breadcrumb1.push({
                    label: product.name_en,
                    href: ""
                });
                setBreadcrumbs(_breadcrumb1);
            }
        }
    }, [
        product,
        productDetailPreBreadcrumb,
        router
    ]);
    // ** set product attributes formatted on mount
    (0,react.useEffect)(()=>{
        if (product && product.attributes && product.attributeOptions && product.attributeOrders) {
            var _product_attributes;
            // sort productAttributeOrder by sequence asc
            const sortedProductAttributeOrder = product.attributeOrders.sort((a, b)=>a.sequence - b.sequence);
            const _productAttributes = ((_product_attributes = product.attributes) === null || _product_attributes === void 0 ? void 0 : _product_attributes.filter((attribute)=>attribute)) || [];
            // map productAttributeOrder to productAttribute
            const productAttributesSorted = sortedProductAttributeOrder.map((productAttributeOrder)=>{
                const productAttribute = _productAttributes.find((productAttribute)=>{
                    return (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.id) === (productAttributeOrder === null || productAttributeOrder === void 0 ? void 0 : productAttributeOrder.attributeId);
                });
                return productAttribute;
            }).filter((productAttribute)=>productAttribute !== undefined);
            // format product attributes
            const _productAttributesFormatted = productAttributesSorted.map((attribute)=>{
                const _options = product.attributeOptions ? product.attributeOptions.filter((option)=>{
                    return (option === null || option === void 0 ? void 0 : option.productAttributeId) === (attribute === null || attribute === void 0 ? void 0 : attribute.id);
                }) : [];
                // sort productAttributeOption by sequence asc
                const sortedProductAttributeOption = _options.sort((a, b)=>a.sequence - b.sequence);
                return {
                    ...attribute,
                    options: sortedProductAttributeOption
                };
            }).filter((attribute)=>attribute !== undefined);
            // set product attributes formatted
            setProductAttributesFormatted(_productAttributesFormatted);
        }
    }, [
        product
    ]);
    // ** if product variation is not empty
    // ** set default setCurrentAttributeOptionSelected by first product variation
    (0,react.useEffect)(()=>{
    /* if (
      product &&
      product.variations &&
      product.variations.length > 0 &&
      productAttributesFormatted &&
      productAttributesFormatted.length > 0 &&
      !currentAttributeOptionSelected.length
    ) {
      console.log('productAttributesFormatted', productAttributesFormatted);

      const firstProductVariation = product.variations[0];

      if (
        firstProductVariation &&
        firstProductVariation.attributeOptions &&
        firstProductVariation.attributeOptions.length > 0
      ) {
        const _currentProductVariations = productAttributesFormatted.map(
          (attribute, index) => {
            return {
              attributeId: attribute.id,
              attributeName: attribute.name_th,
              optionId: firstProductVariation!.attributeOptions![index]?.id,
              optionName:
                firstProductVariation!.attributeOptions![index]?.name_th,
            };
          }
        );

        setCurrentAttributeOptionSelected(_currentProductVariations);
      }
    } */ }, [
        product,
        productAttributesFormatted
    ]);
    // ** set product gallery
    const productGallery = (0,react.useMemo)(()=>{
        if (product) {
            if (product.variations && product.variations.length > 0) {
                const variationGallery = product.variations.map((variation)=>{
                    if (variation.gallery) {
                        return variation.gallery.map((media)=>({
                                ...media,
                                uniqueId: variation.id
                            }));
                    } else {
                        return [];
                    }
                });
                const variationGalleryFlat = variationGallery.flat();
                // if product.featuredImage is not null
                // prepend product.featuredImage to variationGallery
                if (product.featuredImage) {
                    variationGalleryFlat.unshift({
                        ...product.featuredImage,
                        uniqueId: product.id
                    });
                }
                return variationGalleryFlat;
            } else {
                // product.gallery is not null
                // prepend product.featuredImage to product.gallery
                if (product.gallery) {
                    const _gallery = product.gallery.map((media)=>({
                            ...media,
                            uniqueId: product.id
                        }));
                    if (product.featuredImage) {
                        _gallery.unshift({
                            ...product.featuredImage,
                            uniqueId: product.id
                        });
                    }
                    return _gallery;
                } else {
                    // product.gallery is null
                    // return product.featuredImage
                    if (product.featuredImage) {
                        return [
                            {
                                ...product.featuredImage,
                                uniqueId: product.id
                            }
                        ];
                    }
                }
            }
        }
        return [];
    }, [
        product
    ]);
    // ** set current product variation when currentAttributeOptionSelected is changed
    (0,react.useEffect)(()=>{
        ;
        if (product && product.variations && currentAttributeOptionSelected.length > 0) {
            const _currentProductVariation = product.variations.find((variation)=>{
                var _variation_attributeOptions;
                return ((_variation_attributeOptions = variation.attributeOptions) === null || _variation_attributeOptions === void 0 ? void 0 : _variation_attributeOptions.every((attributeOption)=>{
                    return currentAttributeOptionSelected.some((optionSelected)=>{
                        return optionSelected.optionId === (attributeOption === null || attributeOption === void 0 ? void 0 : attributeOption.id);
                    });
                })) && variation.attributeOptions.length === currentAttributeOptionSelected.length;
            });
            ;
            if (_currentProductVariation) {
                setCurrentProductVariation(_currentProductVariation);
            } else {
                setCurrentProductVariation(undefined);
            }
        } else {
            setCurrentProductVariation(undefined);
        }
    }, [
        currentAttributeOptionSelected,
        product
    ]);
    // ** set salePrice, regularPrice, stockQuantity when currentProductVariation is changed
    (0,react.useEffect)(()=>{
        var _product_attributes;
        ;
        if (product) {
            if (product.salePrice && product.salePrice > 0) {
                setSalePrice(product.salePrice);
            }
            setRegularPrice(product.regularPrice || 0);
            if (product.stockQuantity && product.stockQuantity > 0) {
                setIsOutOfStock(false);
            } else {
                setIsOutOfStock(true);
            }
        }
        if ((product === null || product === void 0 ? void 0 : product.attributes) && (product === null || product === void 0 ? void 0 : (_product_attributes = product.attributes) === null || _product_attributes === void 0 ? void 0 : _product_attributes.length) > 0) {
            setSalePrice(0);
            setRegularPrice(0);
            setIsOutOfStock(false);
        }
        if (currentProductVariation) {
            if (currentProductVariation.salePrice && currentProductVariation.salePrice > 0) {
                setSalePrice(currentProductVariation.salePrice);
            }
            setRegularPrice(currentProductVariation.regularPrice || 0);
            if (currentProductVariation.stockQuantity && currentProductVariation.stockQuantity > 0) {
                setIsOutOfStock(false);
            } else {
                setIsOutOfStock(true);
            }
        }
    }, [
        currentProductVariation,
        product
    ]);
    // ** handle save or delete wishlist
    const handleSaveOrDeleteWishlist = async ()=>{
        try {
            setWishlistLoading(true);
            if (!user || !user.isAuthenticated) {
                setLoginModalVisible(true);
                return;
            }
            if (!product) {
                return;
            }
            // ** NOTE: if product is not in wishlist
            // save product to wishlist
            if (!wishlist) {
                const wishlistCreated = await user_repository/* default.wishListCreate */.Z.wishListCreate({
                    productId: product.id,
                    variationId: currentProductVariation ? currentProductVariation.id : undefined,
                    attributeOptionIds: currentProductVariation ? currentProductVariation.attributeOptions ? currentProductVariation.attributeOptions.map((option)=>option.id) : [] : []
                });
                ;
                setWishlist(wishlistCreated);
                // append wishlist to wishlist store
                addWishlist(wishlistCreated);
                // set wishlist total
                setWishlistsTotal(wishlistsTotal + 1);
                // show success message
                api.success(t("product.wishlist.toast.saved.title", {
                }));
            } else {
                const wishlistDeleted = await user_repository/* default.wishListDelete */.Z.wishListDelete(wishlist.id);
                ;
                setWishlist(undefined);
                // remove wishlist from wishlist store
                deleteWishlist(wishlist.id);
                // set wishlist total
                setWishlistsTotal(wishlistsTotal - 1);
                // show success message
                api.success(t("product.wishlist.toast.deleted.title", {
                }));
            }
        } catch (error) {
            catchError(error);
        } finally{
            setWishlistLoading(false);
        }
    };
    // ** handle add to cart
    const handleAddToCart = (0,react.useCallback)(async ()=>{
        try {
            setAddToCartLoading(true);
            if (!product) {
                return;
            }
            let _productNameFormatted = router.locale === "th" ? product.name_th : product.name_th;
            var _product_weight;
            let _productWeightFormatted = (_product_weight = product.weight) !== null && _product_weight !== void 0 ? _product_weight : 0;
            if (currentProductVariation) {
                var _currentProductVariation_attributeOptions;
                _productNameFormatted = "".concat(_productNameFormatted, " (").concat((_currentProductVariation_attributeOptions = currentProductVariation.attributeOptions) === null || _currentProductVariation_attributeOptions === void 0 ? void 0 : _currentProductVariation_attributeOptions.map((option)=>router.locale === "th" ? option.name_th : option.name_en).join(" / "), ")");
                var _currentProductVariation_weight;
                _productWeightFormatted = (_currentProductVariation_weight = currentProductVariation.weight) !== null && _currentProductVariation_weight !== void 0 ? _currentProductVariation_weight : 0;
            }
            const initialItem = {
                id: 0,
                productId: product.id,
                variationId: (currentProductVariation === null || currentProductVariation === void 0 ? void 0 : currentProductVariation.id) || 0,
                quantity: quantity,
                price: salePrice,
                regularPrice: regularPrice,
                salePrice: salePrice,
                key: esm_browser_v4(),
                cartId: 0,
                createdAt: new Date(),
                updatedAt: new Date(),
                product,
                attributeOptions: (currentProductVariation === null || currentProductVariation === void 0 ? void 0 : currentProductVariation.attributeOptions) || [],
                subTotal: quantity * salePrice,
                total: quantity * salePrice,
                selected: true,
                weight: _productWeightFormatted,
                weightUnit: "g",
                weightTotal: _productWeightFormatted * quantity,
                buy1Get1Id: null,
                hasBuy1Get1: false,
                buyXGetXId: null,
                maxQuantity: 10
            };
            // ** NOTE: cart is not exist
            // ** create cart
            if (!cart) {
                if (!user || !user.isAuthenticated) {
                    cartUpdate({
                        sessionId: esm_browser_v4(),
                        items: [
                            initialItem
                        ],
                        id: 0,
                        shippingMethodId: 0,
                        shippingAddressId: 0,
                        discount: null,
                        couponDiscountTotal: 0,
                        discountTotal: 0,
                        percentageOffsPromotionsDiscountTotal: 0,
                        createdAt: new Date(),
                        updatedAt: new Date(),
                        shippingTotal: 0,
                        subTotal: quantity * salePrice,
                        total: quantity * salePrice
                    });
                }
            } else {
                // if currentProductVariation
                if (currentProductVariation) {
                    // check stock quantity
                    if (currentProductVariation.stockQuantity && currentProductVariation.stockQuantity <= 0) {
                        setIsOutOfStock(true);
                        return;
                    }
                    const _currentCartItem = cart.items.find((item)=>{
                        var _item_attributeOptions, _currentProductVariation_attributeOptions;
                        return item.productId === product.id && ((_item_attributeOptions = item.attributeOptions) === null || _item_attributeOptions === void 0 ? void 0 : _item_attributeOptions.filter((option)=>{
                            var _currentProductVariation_attributeOptions;
                            return currentProductVariation === null || currentProductVariation === void 0 ? void 0 : (_currentProductVariation_attributeOptions = currentProductVariation.attributeOptions) === null || _currentProductVariation_attributeOptions === void 0 ? void 0 : _currentProductVariation_attributeOptions.find((variationOption)=>variationOption.id === option.id);
                        }).length) === (currentProductVariation === null || currentProductVariation === void 0 ? void 0 : (_currentProductVariation_attributeOptions = currentProductVariation.attributeOptions) === null || _currentProductVariation_attributeOptions === void 0 ? void 0 : _currentProductVariation_attributeOptions.length);
                    });
                    if (user && user.isAuthenticated) {
                        var _currentProductVariation_attributeOptions1;
                        // add product to cart
                        const cartUpdated = await cart_repository/* CartRepository.addOrUpdateItemToCart */.e.addOrUpdateItemToCart({
                            key: _currentCartItem === null || _currentCartItem === void 0 ? void 0 : _currentCartItem.key,
                            productId: product.id,
                            variationId: currentProductVariation.id,
                            quantity: quantity,
                            attributeOptionIds: currentProductVariation ? (_currentProductVariation_attributeOptions1 = currentProductVariation.attributeOptions) === null || _currentProductVariation_attributeOptions1 === void 0 ? void 0 : _currentProductVariation_attributeOptions1.map((option)=>option.id) : []
                        });
                        setCart({
                            ...cartUpdated,
                            items: cartUpdated.items
                        });
                        cartMutate({
                            ...cartUpdated,
                            items: cartUpdated.items
                        }, false);
                    } else {
                        const cartUpdated1 = {
                            ...cart,
                            items: _currentCartItem ? cart.items.map((item)=>{
                                item.selected = true;
                                if (item.key === _currentCartItem.key) {
                                    return {
                                        ...item,
                                        quantity: item.quantity + quantity
                                    };
                                } else {
                                    return item;
                                }
                            }) : [
                                ...cart.items,
                                initialItem
                            ]
                        };
                        setCart(cartUpdated1);
                    }
                } else {
                    // ** NOTE: is product
                    // check product stock quantity
                    if (product.stockQuantity && product.stockQuantity <= 0) {
                        setIsOutOfStock(true);
                        return;
                    }
                    const _currentCartItem1 = cart.items.find((item)=>{
                        var _item_attributeOptions;
                        return item.productId === product.id && ((_item_attributeOptions = item.attributeOptions) === null || _item_attributeOptions === void 0 ? void 0 : _item_attributeOptions.length) === 0;
                    });
                    if (user && user.isAuthenticated) {
                        // add product to cart
                        const cartUpdated2 = await cart_repository/* CartRepository.addOrUpdateItemToCart */.e.addOrUpdateItemToCart({
                            key: _currentCartItem1 === null || _currentCartItem1 === void 0 ? void 0 : _currentCartItem1.key,
                            productId: product.id,
                            quantity: quantity
                        });
                        setCart({
                            ...cartUpdated2,
                            items: cartUpdated2.items
                        });
                        cartMutate({
                            ...cartUpdated2,
                            items: cartUpdated2.items
                        }, false);
                    } else {
                        const cartUpdated3 = {
                            ...cart,
                            items: _currentCartItem1 ? cart.items.map((item)=>{
                                item.selected = true;
                                if (item.key === _currentCartItem1.key) {
                                    return {
                                        ...item,
                                        quantity: item.quantity + quantity
                                    };
                                } else {
                                    return item;
                                }
                            }) : [
                                ...cart.items,
                                initialItem
                            ]
                        };
                        cartUpdate({
                            ...cartUpdated3,
                            items: cartUpdated3.items
                        });
                    }
                }
            }
            // show message
            api.success(t("product.cart.toast.added.title", {
                // TH: เพิ่มสินค้า {{name}} ลงในตะกร้าแล้ว
                // EN: Add {{name}} to cart successfully
                name: _productNameFormatted
            }));
        } catch (error) {
            catchError(error);
        } finally{
            setAddToCartLoading(false);
        }
    }, [
        cart,
        user,
        currentProductVariation,
        product,
        regularPrice,
        salePrice,
        quantity
    ]);
    if (!product) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Container */.W2, {
            py: {
                base: 4,
                lg: 16
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Grid */.rj, {
                templateColumns: {
                    base: "minmax(0, 1fr)",
                    md: "minmax(0, 1fr) minmax(0, 1fr)",
                    lg: "minmax(0, 1fr) minmax(0, 1fr)"
                },
                columnGap: {
                    base: 0,
                    md: 6,
                    lg: 10
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* GridItem */.P4, {
                        position: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Stack */.Kq, {
                                position: "absolute",
                                left: "-70px",
                                top: "0",
                                display: {
                                    base: "none",
                                    lg: "flex"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                        boxSize: "50px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                        boxSize: "50px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                        boxSize: "50px"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                        boxSize: "50px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
                            flexDirection: "column",
                            height: "100%",
                            justifyContent: "space-between",
                            minHeight: "250px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                            height: "20px",
                                            mb: 4
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                            height: "15px",
                                            width: "70%"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                                height: "50px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                                height: "50px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                            flex: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(skeleton_dist_index_esm/* Skeleton */.Od, {
                                                height: "50px"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        });
    }
    if (product.status !== product_interface/* ProductStatusEnum.PUBLISHED */.X.PUBLISHED) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Container */.W2, {
            py: {
                base: 8,
                lg: 20
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                    children: t("product.detail.notFound", {
                    })
                })
            })
        });
    }
    const maxQuantity = currentProductVariation ? currentProductVariation.stockQuantity : product.stockQuantity || 10;
    var _product_description_th, _product_productBadge_imageName, _product_description_th1, _product_brochure, _product_manualGuide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: product && locale === "th" ? product.name_th : product.name_en
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: (_product_description_th = product === null || product === void 0 ? void 0 : product.description_th) !== null && _product_description_th !== void 0 ? _product_description_th : ""
                    })
                ]
            }),
            contextHolder,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                        display: {
                            base: "none",
                            md: "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                            breadcrumb: breadcrumbs
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Container */.W2, {
                        pt: {
                            base: 0,
                            md: 2,
                            lg: 12
                        },
                        pb: {
                            base: 6,
                            md: 10,
                            lg: 12
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                ml: {
                                    base: 0,
                                    lg: "0"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Grid */.rj, {
                                    templateColumns: {
                                        base: "minmax(0, 1fr)",
                                        md: "minmax(0, 1fr) minmax(0, 1fr)",
                                        lg: "minmax(0, 1fr) minmax(0, 1fr)"
                                    },
                                    columnGap: {
                                        base: 0,
                                        md: 6,
                                        lg: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* GridItem */.P4, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                                pr: {
                                                    base: 0,
                                                    lg: 0
                                                },
                                                mb: {
                                                    base: 6,
                                                    md: 0
                                                },
                                                mx: {
                                                    base: -4,
                                                    md: 0
                                                },
                                                position: "relative",
                                                children: [
                                                    product.productBadge ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                        position: "absolute",
                                                        top: "0",
                                                        left: 3,
                                                        zIndex: "docked",
                                                        px: 1,
                                                        minH: "44.1px",
                                                        borderBottomRadius: "4px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                                                            imageName: (_product_productBadge_imageName = product.productBadge.imageName) !== null && _product_productBadge_imageName !== void 0 ? _product_productBadge_imageName : ""
                                                        })
                                                    }) : product.isNewArrival ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                        position: "absolute",
                                                        top: "0",
                                                        left: 3,
                                                        zIndex: "docked",
                                                        px: 1,
                                                        minH: "44.1px",
                                                        borderBottomRadius: "4px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                                                            type: "new"
                                                        })
                                                    }) : product.isBestSeller ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                        position: "absolute",
                                                        top: "0",
                                                        left: 3,
                                                        zIndex: "docked",
                                                        px: 1,
                                                        minH: "44.1px",
                                                        borderBottomRadius: "4px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                                                            type: "best-seller"
                                                        })
                                                    }) : product.isOnSale ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                        position: "absolute",
                                                        top: "0",
                                                        left: 3,
                                                        zIndex: "docked",
                                                        px: 1,
                                                        minH: "44.1px",
                                                        borderBottomRadius: "4px",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBadge/* default */.Z, {
                                                            type: "special-price"
                                                        })
                                                    }) : null,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(products_ProductGallerySwiper, {
                                                        product: product,
                                                        currentProductVariation: currentProductVariation,
                                                        images: productGallery
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* GridItem */.P4, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    pb: {
                                                        base: 0,
                                                        md: 6
                                                    },
                                                    mb: {
                                                        base: 4,
                                                        md: 6
                                                    },
                                                    borderBottom: {
                                                        md: "1px solid #aaa"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                                        fontSize: {
                                                            base: "30px",
                                                            md: "32px",
                                                            lg: "36px"
                                                        },
                                                        textTransform: "uppercase",
                                                        fontWeight: "400",
                                                        color: "gray.800",
                                                        children: locale === "th" ? product.name_th ? product.name_th : product.name_en : product.name_en
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    mb: 6,
                                                    pb: 5,
                                                    display: {
                                                        base: "block",
                                                        md: "none"
                                                    },
                                                    borderBottom: "1px solid #aaa",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                                        spacing: 3,
                                                        alignItems: "baseline",
                                                        children: salePrice > 0 || regularPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    fontSize: "40px",
                                                                    lineHeight: "40px",
                                                                    fontWeight: "400",
                                                                    color: "primary.500",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                        price: salePrice > 0 ? salePrice : regularPrice,
                                                                        format: "0,0"
                                                                    })
                                                                }),
                                                                salePrice > 0 && regularPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    as: "s",
                                                                    fontSize: "20px",
                                                                    color: "gray.400",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                        price: regularPrice
                                                                    })
                                                                })
                                                            ]
                                                        }) : currentProductVariation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    color: "red.300",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InfoCircleFilled, {})
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    color: "red.500",
                                                                    children: t("product.general.notAvailable", {
                                                                    })
                                                                })
                                                            ]
                                                        }) : null
                                                    })
                                                }),
                                                productAttributesFormatted && productAttributesFormatted.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    pb: 6,
                                                    mb: 6,
                                                    borderBottom: "1px solid",
                                                    borderColor: "#aaa",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                                        alignItems: "flex-start",
                                                        spacing: {
                                                            base: 0,
                                                            lg: 6
                                                        },
                                                        flexDirection: {
                                                            base: "column",
                                                            lg: "row"
                                                        },
                                                        children: productAttributesFormatted && productAttributesFormatted.map((attribute, index)=>{
                                                            var _currentAttributeOptionSelected_find, _attribute_options;
                                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                flex: "1",
                                                                maxWidth: {
                                                                    base: "100%",
                                                                    lg: "50%"
                                                                },
                                                                width: {
                                                                    base: "100%",
                                                                    lg: "50%"
                                                                },
                                                                spacing: {
                                                                    base: 0,
                                                                    lg: 4
                                                                },
                                                                flexDirection: {
                                                                    base: "column",
                                                                    lg: "row"
                                                                },
                                                                alignItems: {
                                                                    base: "flex-start",
                                                                    lg: "center"
                                                                },
                                                                mb: {
                                                                    base: 4,
                                                                    lg: 0
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Text */.xv, {
                                                                        flex: "0 0 auto",
                                                                        children: [
                                                                            router.locale === "th" ? attribute.name_th : attribute.name_en,
                                                                            " : "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                        flex: 1,
                                                                        w: {
                                                                            base: "100%",
                                                                            lg: "auto"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(select_dist_index_esm/* Select */.Ph, {
                                                                            size: {
                                                                                base: "md",
                                                                                lg: "sm"
                                                                            },
                                                                            fontSize: "md",
                                                                            icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Center */.M5, {
                                                                                width: "16px !important",
                                                                                height: "10px !important",
                                                                                mr: -2,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    src: "/image-icon/dropdown.png",
                                                                                    width: 16,
                                                                                    height: 10,
                                                                                    alt: "dropdown"
                                                                                })
                                                                            }),
                                                                            value: (_currentAttributeOptionSelected_find = currentAttributeOptionSelected.find((option)=>option.attributeId === attribute.id)) === null || _currentAttributeOptionSelected_find === void 0 ? void 0 : _currentAttributeOptionSelected_find.optionId,
                                                                            placeholder: "---",
                                                                            onChange: (e)=>{
                                                                                // set current attribute option selected
                                                                                // if not exist, push to array
                                                                                // if exist, update value
                                                                                const index = currentAttributeOptionSelected.findIndex((option)=>option.attributeId === attribute.id);
                                                                                if (index !== -1) {
                                                                                    var _attribute_options_find, _attribute_options;
                                                                                    var _attribute_options_find_name_th;
                                                                                    currentAttributeOptionSelected[index] = {
                                                                                        attributeId: attribute.id,
                                                                                        attributeName: attribute.name_th,
                                                                                        optionId: parseInt(e.target.value),
                                                                                        optionName: (_attribute_options_find_name_th = (_attribute_options_find = (_attribute_options = attribute.options) === null || _attribute_options === void 0 ? void 0 : _attribute_options.find((option)=>option.id === parseInt(e.target.value))) === null || _attribute_options_find === void 0 ? void 0 : _attribute_options_find.name_th) !== null && _attribute_options_find_name_th !== void 0 ? _attribute_options_find_name_th : ""
                                                                                    };
                                                                                } else {
                                                                                    var _attribute_options_find1, _attribute_options1;
                                                                                    var _attribute_options_find_name_th1;
                                                                                    currentAttributeOptionSelected.push({
                                                                                        attributeId: attribute.id,
                                                                                        attributeName: attribute.name_th,
                                                                                        optionId: parseInt(e.target.value),
                                                                                        optionName: (_attribute_options_find_name_th1 = (_attribute_options_find1 = (_attribute_options1 = attribute.options) === null || _attribute_options1 === void 0 ? void 0 : _attribute_options1.find((option)=>option.id === parseInt(e.target.value))) === null || _attribute_options_find1 === void 0 ? void 0 : _attribute_options_find1.name_th) !== null && _attribute_options_find_name_th1 !== void 0 ? _attribute_options_find_name_th1 : ""
                                                                                    });
                                                                                }
                                                                                // set current attribute option selected
                                                                                setCurrentAttributeOptionSelected([
                                                                                    ...currentAttributeOptionSelected
                                                                                ]);
                                                                            },
                                                                            children: (_attribute_options = attribute.options) === null || _attribute_options === void 0 ? void 0 : _attribute_options.map((option)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                                    value: option.id,
                                                                                    children: router.locale === "th" ? option.name_th : option.name_en
                                                                                }, option.id))
                                                                        })
                                                                    })
                                                                ]
                                                            }, attribute.id);
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    pb: 6,
                                                    mb: 6,
                                                    borderBottom: "1px solid",
                                                    borderColor: "#aaa",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                        maxW: {
                                                            base: "100%"
                                                        },
                                                        spacing: 4,
                                                        justifyContent: {
                                                            base: "space-between",
                                                            lg: "flex-start"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                children: t("product.label.amount", {
                                                                })
                                                            }),
                                                            !isOutOfStock ? /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                flex: "0 0 100px",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNumber/* default */.Z, {
                                                                    step: 1,
                                                                    min: 1,
                                                                    max: maxQuantity || 0,
                                                                    value: quantity,
                                                                    isDisabled: isOutOfStock,
                                                                    onChange: (value)=>setQuantity(+value)
                                                                })
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                mt: 3,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                        color: "red.300",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InfoCircleFilled, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                        color: "red.500",
                                                                        children: t("product.label.general.outOfStock", {
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    mb: 6,
                                                    display: {
                                                        base: "none",
                                                        md: "block"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* HStack */.Ug, {
                                                        spacing: 3,
                                                        alignItems: "baseline",
                                                        children: salePrice > 0 || regularPrice > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    fontSize: "54px",
                                                                    lineHeight: "50px",
                                                                    fontWeight: "400",
                                                                    color: "primary.500",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                        price: salePrice > 0 ? salePrice : regularPrice,
                                                                        format: "0,0"
                                                                    })
                                                                }),
                                                                salePrice > 0 && regularPrice > 0 && salePrice !== regularPrice && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    as: "s",
                                                                    fontSize: "24px",
                                                                    color: "gray.400",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UtilPriceFormatter/* default */.Z, {
                                                                        price: regularPrice
                                                                    })
                                                                })
                                                            ]
                                                        }) : currentProductVariation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    color: "red.300",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_InfoCircleFilled, {})
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                    color: "red.500",
                                                                    children: t("product.general.notAvailable", {
                                                                    })
                                                                })
                                                            ]
                                                        }) : null
                                                    })
                                                }),
                                                isTablet && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                flex: "1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                    height: "44px",
                                                                    borderRadius: "4px",
                                                                    width: "100%",
                                                                    disabled: salePrice === 0 && regularPrice === 0 || isOutOfStock,
                                                                    className: "add-to-cart-button",
                                                                    onClick: handleAddToCart,
                                                                    isLoading: addToCartLoading,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                                flex: "0 0 20px",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                    src: "/image-icon/shopping-bag-white.png",
                                                                                    alt: "shopping-bag",
                                                                                    width: 32,
                                                                                    height: 42
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                                flex: 1,
                                                                                fontWeight: "500",
                                                                                textTransform: "uppercase",
                                                                                children: t("product.button.addToCart", {
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                flex: "0 0 auto",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                    height: "44px",
                                                                    borderRadius: "4px",
                                                                    colorScheme: "red",
                                                                    onClick: handleSaveOrDeleteWishlist,
                                                                    isLoading: wishlistLoading,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: wishlist ? "/image-icon/wishlist-active.png" : "/image-icon/wishlist-inactive.png",
                                                                        alt: "shopping-bag",
                                                                        width: 30,
                                                                        height: 28
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                flex: 1,
                                                                display: {
                                                                    base: "none",
                                                                    lg: "block"
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: "https://line.me/R/ti/p/@lamptan",
                                                                    target: "_blank",
                                                                    legacyBehavior: true,
                                                                    passHref: true,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                                        height: "44px",
                                                                        borderRadius: "4px",
                                                                        bg: "#06C755",
                                                                        px: 1,
                                                                        _hover: {
                                                                            bg: "#05ac49"
                                                                        },
                                                                        _active: {
                                                                            bg: "#05ac49"
                                                                        },
                                                                        as: "a",
                                                                        target: "_blank",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                            spacing: 1,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                                    flex: "0 0 22px",
                                                                                    pt: 1,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                        src: "/image-icon/line-icon-button.png",
                                                                                        alt: "shopping-bag",
                                                                                        width: 28,
                                                                                        height: 26
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                                    flex: "1",
                                                                                    fontSize: locale === "th" ? "md" : "sm",
                                                                                    children: t("product.button.line", {
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                !isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    mt: {
                                                        base: 0,
                                                        md: 4
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "https://line.me/R/ti/p/@lamptan",
                                                        target: "_blank",
                                                        legacyBehavior: true,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                                            height: "44px",
                                                            borderRadius: "4px",
                                                            bg: "#06C755",
                                                            px: 1,
                                                            _hover: {
                                                                bg: "#05ac49"
                                                            },
                                                            _active: {
                                                                bg: "#05ac49"
                                                            },
                                                            width: "100%",
                                                            as: "a",
                                                            target: "_blank",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                                        flex: "0 0 23px",
                                                                        pt: 1,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/image-icon/line-icon-button.png",
                                                                            alt: "shopping-bag",
                                                                            width: 32,
                                                                            height: 30
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                                                        flex: "1",
                                                                        children: t("product.button.line", {
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            product.description_th && /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Box */.xu, {
                                borderTop: "1px solid",
                                borderColor: "#aaa",
                                mt: {
                                    base: 6,
                                    lg: 8
                                },
                                pt: 7,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                                        fontSize: "2xl",
                                        mb: 4,
                                        fontWeight: "400",
                                        color: "gray.800",
                                        textTransform: "uppercase",
                                        children: t("product.detail.description.title", {
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                        className: "entry-content",
                                        dangerouslySetInnerHTML: {
                                            __html: (_product_description_th1 = product.description_th) !== null && _product_description_th1 !== void 0 ? _product_description_th1 : ""
                                        }
                                    })
                                ]
                            }),
                            product.brochure && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                borderTop: "1px solid",
                                borderColor: "#aaa",
                                mt: 8,
                                pt: 7,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                    dangerouslySetInnerHTML: {
                                        __html: (_product_brochure = product.brochure) !== null && _product_brochure !== void 0 ? _product_brochure : ""
                                    }
                                })
                            }),
                            product.manualGuide && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                mt: 8,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* Accordion */.UQ, {
                                    allowMultiple: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                                        border: "0",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                                bg: "#29241E",
                                                color: "white",
                                                _hover: {
                                                    bg: "#29241E",
                                                    color: "white"
                                                },
                                                fontSize: "28px",
                                                fontWeight: 200,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                        flex: "1",
                                                        textAlign: "left",
                                                        textTransform: "uppercase",
                                                        children: t("product.detail.manualGuide.title", {
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionIcon */.XE, {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                                px: 0,
                                                pt: {
                                                    base: 6,
                                                    lg: 4
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (_product_manualGuide = product.manualGuide) !== null && _product_manualGuide !== void 0 ? _product_manualGuide : ""
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_AuthLoginModal, {
                visible: loginModalVisible,
                onClose: ()=>setLoginModalVisible(false)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                pos: "fixed",
                bottom: 0,
                left: 0,
                w: "100%",
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                    spacing: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            flex: "0 0 auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                height: "60px",
                                borderRadius: "0px",
                                colorScheme: "red",
                                onClick: handleSaveOrDeleteWishlist,
                                isLoading: wishlistLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: wishlist ? "/image-icon/wishlist-active.png" : "/image-icon/wishlist-inactive.png",
                                    alt: "shopping-bag",
                                    width: 30,
                                    height: 28
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                            flex: "1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                                height: "60px",
                                borderRadius: "0px",
                                width: "100%",
                                disabled: salePrice === 0 && regularPrice === 0 || isOutOfStock,
                                fontSize: "20px",
                                className: "add-to-cart-button",
                                onClick: handleAddToCart,
                                isLoading: addToCartLoading,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Box */.xu, {
                                            flex: "0 0 20px",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/image-icon/shopping-bag-white.png",
                                                alt: "shopping-bag",
                                                width: 32,
                                                height: 42
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                                            flex: 1,
                                            fontWeight: "500",
                                            children: t("product.button.addToCart", {
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ProductDetailPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RootLayout/* default */.Z, {
        pb: {
            base: "50px",
            lg: 0
        },
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (ProductDetailPage);


/***/ }),

/***/ 48238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserRepository; }
/* harmony export */ });
/* harmony import */ var libs_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64232);

class UserRepository {
    /**
   * Get user profile
   * @returns
   */ static profile(accessToken) {
        return new Promise(async (resolve, reject)=>{
            try {
                // if accessToken
                if (accessToken) {
                    const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/public/profile", {
                        headers: {
                            Authorization: "Bearer ".concat(accessToken)
                        }
                    });
                    return resolve(data);
                } else {
                    const { data: data1  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/v1/public/profile");
                    return resolve(data1);
                }
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * update user profile
   * @returns
   */ static updateDetail(payload) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/profile", payload);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Change user password
   * @param payload
   * @returns
   */ static changePassword(payload) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/profile/change-password", payload);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Setting user password
   * @param payload
   * @returns
   */ static settingPassword(payload) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/profile/create-password", payload);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Add address
   * @returns
   */ static createAddress(payload) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/profile/address", payload);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Update address
   * @param id
   * @param payload
   * @returns
   */ static async updateAddress(id, payload) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .Z.patch("/v1/public/profile/address/".concat(id), payload);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    /**
   * Delete address
   * @param id
   * @returns
   */ static deleteAddress(id) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/v1/public/profile/address/".concat(id));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static async wishListCreate(body) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/v1/public/profile/wishlists", body);
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    static async wishListDelete(id) {
        return new Promise(async (resolve, reject)=>{
            try {
                const { data  } = await libs_axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"]["delete"] */ .Z["delete"]("/v1/public/profile/wishlists/".concat(id));
                return resolve(data);
            } catch (error) {
                reject(error);
            }
        });
    }
    constructor(){}
}



/***/ }),

/***/ 42139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useProductStore; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

const useProductStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)((set)=>({
        productDetailPreBreadcrumb: [],
        setProductDetailPreBreadcrumb: (payload)=>set(()=>({
                    productDetailPreBreadcrumb: payload
                }))
    }));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,1559,2077,2883,6324,7001,719,9806,9774,2888,179], function() { return __webpack_exec__(95159); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);